import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from '../src/Login';



import { useEffect } from 'react';
import AdmissionEnquiryForm from './AdmissionEnquiryForm';
import ProgramCards from './ProgramCards';
import Payment from '../src/asse/asse/payment';
import Dashboard from './Dashboard';


function App() {
  
  return (
    <div className="App">
      
      <Router>
        <Routes>
                
                 <Route path="/" element={<Login/>}/>
                 <Route path="/AdmissionEnquiryForm" element={<AdmissionEnquiryForm/>}/>
                 <Route path="/ProgramCards" element={<ProgramCards/>}/>
                 <Route path="/Payments" element={<Payment/>}/>
                 
                 <Route path="/admin@dashboard" element={<Dashboard/>}/>
        </Routes>
      </Router>
      
    </div>
  );
}

export default App;